export default {
    connect: null,
    handlers: {},

    install(Vue) {
        // this.connecting();
        Vue.prototype.$socket = this;
    },
    connecting() {
        this.connect = new WebSocket(process.env.VUE_APP_API_SOCKET);

        this.connect.onmessage = (data => {
            this.getMessage(data);
        });

        this.connect.onerror = (error) => {
            console.log('socket, onerror, ', error); // TODO log
            setTimeout(() => {
                this.connecting();
            }, 30000);
        };

        this.connect.onclose = (event) => {
            console.log('socket, onclose, ', event); // TODO log
            // setTimeout(() => {
            //     this.connecting();
            // }, 30000);
        };
    },
    getMessage(data) {
        let d = JSON.parse(data.data);
        if (this.handlers[d.name] != undefined) {
            this.handlers[d.name](d.model);
        }
    },
    registerHandler(name, func) {
        if (name !== '' && typeof func === 'function') {
            this.handlers[name] = func;
        }
    },
    deleteHandler(name) {
        delete(this.handlers[name]);
    }
}